@use '@/styles/tokens' as *;

.button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 2px;
  border: none;
  border-radius: $radius-sm;
  background: none;
  color: var(--text-muted);
  cursor: pointer;
  transition: color 0.15s ease;

  &:hover {
    color: var(--text-primary);
  }

  &:focus-visible {
    outline: none;
    box-shadow: var(--focus-ring);
  }
}
